

















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class PaginateButton extends Vue {
  /* １ページ表示数 */
  @Prop({ default: process.env.VUE_APP_PAGINATE_DEFAULT_DISPLAY_COUNT })
  private displayCount!: number
  /* 選択ページを中心とした表示数 */
  @Prop({ default: 5 })
  private pageRange!: number
  /* 選択ページ外の表示数 */
  @Prop({ default: 3 })
  private marginPages!: number

  /** ページネーション対象配列 */
  private paginateList: any[] = []
  /** ページ総数 */
  private pageCount = 0
  /** 表示ページ */
  private viewPage = 1
  /** ページネーションボタンの表示状態 */
  private isButtonView = false

  /**
   * 初期処理
   */
  init(paginateList: any[], isPageReset = true) {
    this.isButtonView = false
    if (paginateList.length > this.displayCount) this.isButtonView = true
    const setPage = isPageReset ? 1 : this.viewPage
    this.paginateList = paginateList
    this.pageCount = Math.ceil(paginateList.length / this.displayCount)
    this.viewPageSelect(setPage)
  }

  /**
   * ページ選択処理
   */
  private viewPageSelect(pageNum: number) {
    this.viewPage = pageNum
    const paginateList = this.paginateList.slice(
      this.displayCount * (this.viewPage - 1),
      this.displayCount * this.viewPage
    )
    this.$emit('click-handler', paginateList)
  }
}
